import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {SettingsNewRoutingModule} from './settings-new-routing-module';
import {SETTINGS_COMPONENTS} from './components';
import {UiComponentsModule} from '../../shared/shared-module-ui/ui-components.module';
import {SharedIconsModule} from '../../shared-modules/shared-icons/shared-icons.module';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {settingReducer} from './store/setting.reducer';
import {SettingEffects} from './store/setting.effects';
import {documentLayoutReducer} from './store/document-layout.reducer';
import {DocumentLayoutEffects} from './store/document-layout.effects';
import {
  SharedWidgetContainerComponent,
} from '../../shared/components-standalone/shared-widget-container-component/shared-widget-container.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PhoneMaskDirective} from '../../shared/shared-module-ui/directives/phone-mask/phone-mask.directive';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {SharedComponentsModule} from '../../shared/shared-components/shared-components.module';
import {MatTooltip} from '@angular/material/tooltip';
import {EmailSettingsComponent} from './components/email-settings/email-settings.component';

@NgModule({
  declarations: [
    SETTINGS_COMPONENTS,
  ],
  imports: [
    CommonModule,
    SettingsNewRoutingModule,
    StoreModule.forFeature('setting', settingReducer),
    StoreModule.forFeature('documentLayouts', documentLayoutReducer),
    EffectsModule.forFeature([SettingEffects, DocumentLayoutEffects]),
    UiComponentsModule,
    SharedIconsModule,
    SharedWidgetContainerComponent,
    ReactiveFormsModule,
    FormsModule,
    PhoneMaskDirective,
    DragDropModule,
    SharedComponentsModule,
    MatTooltip,
    EmailSettingsComponent,
  ]
})
export class SettingsNewModule {
}
